<template>
  <!-- Rendered inside the workspace shell (sidebar + header): a view's functions
       are its own in-page toolbar, placed above this column (spec §5), so this
       carries no title/subtitle/actions row of its own — it is just the routed
       content's width container. -->
  <PageFrame width="form" class="text-body">
    <slot />
  </PageFrame>
</template>

<script setup lang="ts">
import { PageFrame } from '@lumi/ui';
</script>
